module.exports = __webpack_public_path__ + "b248d8add01818215c02fd38288d4510.fbx";